export default "__VITE_ASSET__QC_GrFYc__"